function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { createContext, useContext, useMemo } from 'react';
import { ensureArray, isArray, isAssigned, isFunction, isUndefined } from '@okee-uikit/react-utils';
import { useRefCallback, useControllable } from '@okee-uikit/react-hooks';
export function useTableColumnsInit(outerColumns) {
  var rtl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var columnsOptions = arguments.length > 2 ? arguments[2] : undefined;

  var _ref = columnsOptions || {},
      onChange = _ref.onChange,
      controlled = _ref.controlled,
      resizable = _ref.resizable;

  var _useControllable = useControllable({
    value: outerColumns,
    onChange: onChange,
    controlled: controlled
  }),
      _useControllable2 = _slicedToArray(_useControllable, 2),
      innerColumns = _useControllable2[0],
      setInnerColumns = _useControllable2[1];

  return useMemo(function () {
    function getColumnInfos(array, parent) {
      var _ref2 = parent || {},
          _ref2$level = _ref2.level,
          parenLevel = _ref2$level === void 0 ? 0 : _ref2$level,
          _ref2$path = _ref2.path,
          parentPath = _ref2$path === void 0 ? [] : _ref2$path;

      var level = parenLevel + 1;
      return array.map(function (props, index) {
        var _a;

        var key = props.key,
            propId = props.id,
            width = props.width,
            minWidth = props.minWidth,
            maxWidth = props.maxWidth,
            _props$widthFixed = props.widthFixed,
            widthFixed = _props$widthFixed === void 0 ? false : _props$widthFixed,
            _props$fixed = props.fixed,
            propFixed = _props$fixed === void 0 ? false : _props$fixed,
            _props$show = props.show,
            show = _props$show === void 0 ? true : _props$show,
            renderHead = props.renderHead,
            propTitle = props.title,
            dataIndex = props.dataIndex,
            _props$dataProp = props.dataProp,
            dataProp = _props$dataProp === void 0 ? dataIndex : _props$dataProp,
            propRender = props.render,
            propChildren = props.children,
            align = props.align,
            valign = props.valign,
            _props$ellipsis = props.ellipsis,
            ellipsis = _props$ellipsis === void 0 ? false : _props$ellipsis,
            maxLine = props.maxLine,
            maxLines = props.maxLines,
            className = props.className,
            _props$cellProps = props.cellProps,
            propCellProps = _props$cellProps === void 0 ? {
          align: align,
          valign: valign,
          ellipsis: ellipsis,
          maxLine: maxLine,
          maxLines: maxLines,
          className: className
        } : _props$cellProps,
            _props$headCellProps = props.headCellProps,
            propHeadCellProps = _props$headCellProps === void 0 ? {
          align: align,
          valign: valign,
          ellipsis: ellipsis,
          maxLine: maxLine,
          maxLines: maxLines,
          className: className
        } : _props$headCellProps,
            filters = props.filters,
            filterMultiple = props.filterMultiple,
            defaultFilterValue = props.defaultFilterValue,
            onFilter = props.onFilter,
            propFilterOptions = props.filterOptions,
            sortDirections = props.sortDirections,
            defaultOrder = props.defaultOrder,
            sorter = props.sorter,
            propSortOptions = props.sortOptions,
            propResizable = props.resizable;
        var id = (_a = propId !== null && propId !== void 0 ? propId : key) !== null && _a !== void 0 ? _a : index.toString();
        var path = [].concat(_toConsumableArray(parentPath), [id]);
        var isLeaf = !isArray(propChildren) || propChildren.length === 0;

        var title = isFunction(propTitle) && propTitle || isAssigned(propTitle) && function () {
          return propTitle;
        } || isFunction(renderHead) && function (context) {
          return renderHead({
            sortDirections: [],
            order: 'reset',
            onOrderClick: function onOrderClick() {}
          });
        } || function () {
          return undefined;
        };

        var render = !isLeaf && function () {
          return undefined;
        } || isFunction(propRender) && function (rowInfo) {
          return propRender(rowInfo.row, rowInfo);
        } || dataProp && function (_ref3) {
          var row = _ref3.row;
          return row[dataProp];
        } || function () {
          return undefined;
        };

        var fixed;

        switch (propFixed) {
          case 'start':
          case 'end':
            fixed = propFixed;
            break;

          case 'left':
            fixed = rtl && 'end' || 'start';
            break;

          case 'right':
            fixed = rtl && 'start' || 'end';
            break;

          default:
            fixed = false;
        }

        var cellProps = isFunction(propCellProps) && propCellProps || function () {
          return propCellProps;
        };

        var headCellProps = isFunction(propHeadCellProps) && propHeadCellProps || function () {
          return propHeadCellProps;
        };

        var filterOptions = isAssigned(propFilterOptions) && propFilterOptions || isArray(filters) && {
          data: filters,
          type: filterMultiple && 'multiple' || 'single',
          createPredicate: isFunction(onFilter) && function (filterValues) {
            return function (rowInfo) {
              var values = ensureArray(filterValues);

              for (var i = 0; i < values.length; i++) {
                var value = values[i];

                if (onFilter(value, rowInfo.row, {
                  multiple: !!filterMultiple
                })) {
                  return true;
                }
              }

              return false;
            };
          } || undefined
        } || undefined;
        var sortOptions = isAssigned(propSortOptions) && propSortOptions || isArray(sortDirections) && {
          directions: sortDirections,
          createComparer: isFunction(sorter) && function (direction) {
            return function (a, b) {
              return sorter(a.row, b.row, direction);
            };
          } || undefined
        } || undefined;
        var info = {
          id: id,
          path: path,
          level: level,
          isLeaf: isLeaf,
          colIndex: -1,
          title: title,
          render: render,
          children: undefined,
          width: width,
          minWidth: minWidth !== null && minWidth !== void 0 ? minWidth : widthFixed ? width : undefined,
          maxWidth: maxWidth !== null && maxWidth !== void 0 ? maxWidth : widthFixed ? width : undefined,
          fixed: fixed,
          show: show,
          cellProps: cellProps,
          headCellProps: headCellProps,
          filterOptions: filterOptions,
          sortOptions: sortOptions,
          resizable: isUndefined(propResizable) ? resizable : propResizable
        };
        info.children = !isLeaf && getColumnInfos(propChildren, info) || undefined;
        return info;
      });
    }

    var columns = getColumnInfos(innerColumns, undefined);

    var correctShowReflux = function correctShowReflux(cols) {
      return cols.some(function (col) {
        var children = col.children;

        if (children) {
          var childrenSomeShow = correctShowReflux(children);

          if (!childrenSomeShow) {
            col.show = false;
          }
        }

        return col.show;
      });
    };

    var correctShowFlux = function correctShowFlux(cols, parent) {
      cols.forEach(function (col) {
        if (parent && col.show) {
          col.show = parent.show;
        }

        var children = col.children;

        if (children) {
          correctShowFlux(children, col);
        }
      });
    };

    correctShowReflux(columns);
    correctShowFlux(columns, undefined);

    var mapFixedNumeric = function mapFixedNumeric(fixed) {
      return fixed === 'start' && -1 || fixed === 'end' && 1 || 0;
    };

    columns.sort(function (a, b) {
      return mapFixedNumeric(a.fixed) - mapFixedNumeric(b.fixed);
    });
    var deep = 0;
    var colIndex = 1;
    var leafColumns = [];

    var processLeaf = function processLeaf(cols, parent) {
      return cols.forEach(function (col) {
        if (parent) {
          col.fixed = parent.fixed;
        }

        var show = col.show,
            level = col.level,
            children = col.children;
        deep = level > deep && level || deep;
        col.colIndex = colIndex;

        if (children) {
          processLeaf(children, col);
        } else {
          colIndex++;

          if (show) {
            leafColumns.push(col);
          }
        }
      });
    };

    processLeaf(columns, undefined);
    return {
      deep: deep,
      colCount: colIndex - 1,
      columns: columns,
      leafColumns: leafColumns,
      innerColumns: innerColumns,
      setInnerColumns: setInnerColumns,
      resizable: resizable
    };
  }, [innerColumns]);
}
export var ColumnsContext = createContext({
  deep: 0,
  colCount: 0,
  columns: [],
  leafColumns: [],
  innerColumns: [],
  setInnerColumns: function setInnerColumns() {},
  resizable: false
});
export var useTableColumns = function useTableColumns() {
  return useContext(ColumnsContext);
};

function useCellPropsMemo(rawCellProps) {
  var isCellPropsFunction = isFunction(rawCellProps);
  var cellPropsFunction = useRefCallback(isCellPropsFunction && rawCellProps || function () {
    return rawCellProps;
  });
  var deps = rawCellProps;
  return useMemo(function () {
    if (isCellPropsFunction) {
      return cellPropsFunction;
    }

    return function () {
      return rawCellProps;
    };
  }, [isCellPropsFunction, deps.align, deps.valign, deps.ellipsis, deps.maxLine, deps.maxLines, deps.className]);
}

export function useClearTableColumn(rawColumn) {
  var id = rawColumn.id,
      width = rawColumn.width,
      widthFixed = rawColumn.widthFixed,
      fixed = rawColumn.fixed,
      show = rawColumn.show,
      rawTitle = rawColumn.title,
      dataProp = rawColumn.dataProp,
      rawRender = rawColumn.render,
      align = rawColumn.align,
      valign = rawColumn.valign,
      ellipsis = rawColumn.ellipsis,
      maxLine = rawColumn.maxLine,
      maxLines = rawColumn.maxLines,
      className = rawColumn.className,
      _rawColumn$cellProps = rawColumn.cellProps,
      rawCellProps = _rawColumn$cellProps === void 0 ? {
    align: align,
    valign: valign,
    ellipsis: ellipsis,
    maxLine: maxLine,
    maxLines: maxLines,
    className: className
  } : _rawColumn$cellProps,
      _rawColumn$headCellPr = rawColumn.headCellProps,
      rawHeadCellProps = _rawColumn$headCellPr === void 0 ? {
    align: align,
    valign: valign,
    ellipsis: ellipsis,
    maxLine: maxLine,
    maxLines: maxLines,
    className: className
  } : _rawColumn$headCellPr;
  var isTitleFunction = isFunction(rawTitle);
  var titleFunction = useRefCallback(isTitleFunction && rawTitle || function () {
    return rawTitle;
  });
  var isRenderFunction = isFunction(rawRender);
  var renderFunction = useRefCallback(isRenderFunction && rawRender || undefined);
  var cellProps = useCellPropsMemo(rawCellProps);
  var headCellProps = useCellPropsMemo(rawHeadCellProps);
  return useMemo(function () {
    return {
      id: id,
      width: width,
      widthFixed: widthFixed,
      fixed: fixed,
      show: show,
      title: isTitleFunction && titleFunction || rawTitle,
      dataProp: dataProp,
      render: isRenderFunction && renderFunction || undefined,
      cellProps: cellProps,
      headCellProps: headCellProps
    };
  }, [id, width, widthFixed, fixed, show, isTitleFunction || rawTitle, dataProp, isRenderFunction, cellProps, headCellProps]);
}